import * as THREE from "three"
import React, { createRef, Suspense, useEffect, useRef, useState, forwardRef, useLayoutEffect, useDeferredValue } from "react"
import { Canvas, useThree, useFrame } from "@react-three/fiber"
import { BakeShadows, Box, ScrollControls, Scroll, useScroll, useAnimations, useProgress, Html, Environment, useGLTF, ContactShadows,PresentationControls,useMatcapTexture,Sparkles, Float, Sphere } from "@react-three/drei"
import { CameraControls } from './camera-controls';
import './index.css';
import { modelPositions } from "./modelData"
import Lottie from 'react-lottie';
import * as scrollData from "./scroll-animation.json"
import * as interactData from "./Interact_Icon.json";
import {ReactComponent as POSLogo} from '../../assets/img/pos-loader.svg';

const contentPath = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ?  "./" : "/hubfs/307663/PresentationOS/POS%20Demo/"
const mobileBreakPoint = 767;

const Apollo = forwardRef((props, ref) => {
  const apollo = useGLTF(`${contentPath}hero/Apollo_2.glb`)
  // const group = createRef();

   const scroll = useScroll()
   const [callOuts, setCallouts] = useState([false, false, false])
   const {clips, mixer} = useAnimations(apollo.animations, apollo.scene)
   const action = mixer.clipAction( clips[0], apollo.scene )
   action.loop = THREE.LoopOnce
   action.clampWhenFinished = true
   const position = props.position
   
  const screenWidth = ScreenWidth()


   useEffect(() => { 
       console.log(props.currentScene)
       if(props.currentScene == 2){
            action.reset()
            action.timeScale = 1;
            action.setLoop(THREE.LoopOnce);
            action.clampWhenFinished = true;
            action.play();
            setCallouts([true, true, true])
       } else {
           
        if(action.time === 0) {
            action.time = action.getClip().duration;
        }
        action.paused = false;
        action.setLoop(THREE.LoopOnce);      
        action.timeScale = -1;
        action.play();
        setCallouts([false, false, false])

       }
  }, [action, props.currentScene])

//    useFrame((state, delta) => {
//     if(scroll.offset > 0.75){
//       var c = THREE.MathUtils.smoothstep(scroll.offset, 0.75, 1)
//       action.time = THREE.MathUtils.damp(action.time, (action.getClip().duration / 2) * c, 100, delta)
//       var callTemp = [false, false, false]
//       callTemp[0] = (c >= 0.2 )
//       callTemp[1] = (c >= 0.4)
//       callTemp[2] = (c >= 0.8)
//       if(callTemp[0]!=callOuts[0] || callTemp[1]!=callOuts[1] || callTemp[2]!=callOuts[2])
      
//       setCallouts(callTemp)
     
//     }
//    })



  const door = apollo.scene.getObjectByName("Door").children[2]
  door.material.metalness = 0.8
  door.material.roughness = 0
  door.material.color = new THREE.Color(0xa6bfce)

  const capsule = apollo.scene.getObjectByName("Capsule_out").children[1]
  capsule.material.metalness = 0.8
  capsule.material.roughness = 0
  capsule.material.color = new THREE.Color(0xa6bfce)

  const scale = (screenWidth > mobileBreakPoint) ? 70 : 140;

  return (
    <group >
    {/*<primitive  object={moon.scene} position={[20,-30.15,15]}  scale={[1.5,1.5,1.5]} rotation={[0, THREE.MathUtils.degToRad(0), 0]}  />*/}
    <Sparkles count={1000} scale={16 * 2} size={10} speed={0.1} opacity={0.3} noise={10} position={[0,-31.5,0]} />

        <group  position={position}>
        <CallOut position={[-1,1,-5]} side="left" isVisible={callOuts[0]}>See inside models with detail</CallOut>
        <CallOut position={[2,1,0]} isVisible={callOuts[1]}>Add infopoints where most useful</CallOut>
        {(screenWidth > 480) ? <CallOut position={[0,1,5]} isVisible={callOuts[2]}>Link to more content or websites</CallOut> : null }
        
        <primitive  object={apollo.scene} position={[0,0,0]}  scale={[scale,scale,scale]}   />
        </group>
      
    
    </group>
  )
});

const CallOut = (props) => {
  var styleSide = (props.side) ? props.side : ""
  var isVisible = (props.isVisible) ? "show" : ""

  useEffect(() => {
    
  }, [props.isVisible])

  return (
    <group position={props.position}>
      <Html>
        <div className={`callOut ${styleSide} ${isVisible}`}>
          <span>{props.children}</span>
        </div>
      </Html>
    </group>
  )
}

const ScreenWidth = () => {
    const [screenWidth, setScreenWidth] = useState(window.innerWidth)
    const deferredValue = useDeferredValue(screenWidth, {
        timeoutMs: 5000
      });
    useLayoutEffect(() => {
      const handleResize = () => {
        const { innerWidth } = window
        setScreenWidth(innerWidth)
      }
      window.addEventListener('resize', handleResize)
      return () => window.removeEventListener('resize', handleResize)
    }, [])
    
  
    return deferredValue
  }


const PresentObject = forwardRef((props, ref) => {
    
    const model = useGLTF(props.src, true)
    const [matcap] = useMatcapTexture('424244_BDBBBE_8A898E_A3A4A9')
    var v = createRef()
    var group = createRef()
    var videoObjs = [];
    for(let i in props.videos.objects){
        var s = model.scene.getObjectByName(props.videos.objects[i])
        videoObjs.push(s)
    }
    
    const {
        clips,
        mixer
    } = useAnimations(model.animations, group)
    let action = null;
    if(clips.length > 0){
        action = mixer.clipAction(clips[0], model.scene)
        action.loop = THREE.LoopRepeat
        action.timeScale = 3.5
        action.clampWhenFinished = true
    }
    useEffect(() => {
        if (videoObjs.length > 0) {
            for(let o in videoObjs){
                videoObjs[o].material = v.current.material
                videoObjs[o].material.map.rotation = THREE.MathUtils.degToRad(0)
            }
        }
        if(action){
            
                setTimeout(() => {
                    action.play()
                }, 500)
            
        }
    }, [v, videoObjs, props, action])

    if (!props.src) return;

    const polar = (props.polar) ? props.polar : [0, Math.PI / 2]
    const azimuth = (props.azimuth) ? props.azimuth : [-Infinity, Infinity]
    const scale = (props.scale) ? props.scale : [1, 1, 1]
    const position = (props.position) ? props.position : [0, 0, 0]
    const rotation = (props.rotation) ? props.rotation : [0, 0, 0]
    const shadow = (props.shadowScale) ? props.shadowScale : 1

    

    model.scene.traverse((obj) => {
      if(obj.isMesh){
        if(obj.material.name == "MatCapBuilding"){
          obj.material = new THREE.MeshMatcapMaterial({matcap: matcap})
        }
      }
    })


    return (
        <group position={position} ref={ref} polar={polar} azimuth={azimuth}>
        <VideoPlane refs={v} video={props.videos.file}/>
        
        <primitive ref={group}  object={model.scene} scale={scale}   rotation={rotation}  />
        {/*<ContactShadows position={position} opacity={0.2} scale={shadow} blur={1} far={10} resolution={256} color="#000000" /> */}
        </group>)
})


function VideoPlane(props) {
    
    const [video] = useState(() =>
      Object.assign(document.createElement('video'), { src: props.video, crossOrigin: 'Anonymous', loop: true, muted: "muted", playsinline: true, autoplay: true }),
    )
    useEffect(() => { video.muted = "muted"; video.play() }, [video])
    return (
      <mesh ref={props.refs} scale={0}>
        <planeBufferGeometry  />
        <meshPhongMaterial side={THREE.DoubleSide} toneMapped={false}>
          <videoTexture attach="map" args={[video]} encoding={THREE.sRGBEncoding} />
        </meshPhongMaterial>
      </mesh>
    )
  }

function Loader(props) {
  const { active, progress} = useProgress()
  const [currentProgress, setCurrentProgress] = useState(0)
  const [finishedLoad, setFinishedLoad] = useState(false)

  useEffect(() => {
   if(currentProgress < progress && !finishedLoad){
     setCurrentProgress(progress)
     if(progress === 100){
        setFinishedLoad(true)
     }
   }
  }, [progress])

  return (active) ? (
    <Html center {...props}>
    <span className="modelLoader">
       <div className="pos-loader"><span className="demopos-pos-logo"></span></div>
      <span className="modelLoaderProgress" style={{width: currentProgress + "%"}}>
        {currentProgress.toFixed(0)}%
      </span>
      <span className="modelLoader-text">We're loading your experience</span>
    </span>
    </Html>) : null;
}

function HeroModels(props) {
  const data = useScroll()
  const apolloRef = createRef()
  const maqueteRef = createRef()
  const remoteRef = createRef()
  const [rotateM, setRotateM] = useState(0)
  const [scrollAmount, setScrollAmount] = useState(0)
  const [allowScroll, setScroll] = useState(true)
  const [windowScroll, setWindowScroll] = useState(0)
  const cameraControls = props.cameraControls.current
  const deviceType = props.deviceType
  const animated = props.animated
  useEffect(() => {
      props.enableScroll((windowScroll > 0))
      
    if(!allowScroll && windowScroll === 0){ 
          document.body.classList.add('no-scroll');
        } else if(allowScroll && windowScroll === 0) {
          document.body.classList.remove('no-scroll');
        }

  },[allowScroll, windowScroll, deviceType])
  
//   useFrame(() => {

//     const scrollRange = data.range(1 / 50, 1)
    
//     setWindowScroll(window.scrollY)
   
//     var pct = parseFloat(scrollRange * 100)
//     var v = (pct+2).toFixed(2)
    

//     if(scrollAmount !== v){
      
//       setScrollAmount(v)
//       props.moveScroll(v)
//     }

//     if(v>90){
//       if(!allowScroll){
//         setScroll(true)
//       }
//     } else {
//       if(allowScroll){
//         setScroll(false)
//       } 
//     }
//     var step = parseInt(v)/33
//     var stepNum = THREE.MathUtils.clamp(Math.round(step), 0,2)
//     if(stepNum !== rotateM){
//       setRotateM(stepNum);
//       props.moveModel(stepNum)
//     }
//   })
  
  return (
      <group>
      
        <PresentObject
        ref={maqueteRef}
        src={`${contentPath}hero/Maquete.glb`}
        videos={{"objects": ["Screen", "ScreenKiosk"], "file": `${contentPath}hero/Maquete_3.mp4`}}
        polar={[THREE.MathUtils.degToRad(0), 0]}
        azimuth={[THREE.MathUtils.degToRad(-90), THREE.MathUtils.degToRad(0)]}
        position={modelPositions[0]["translate"][deviceType]} 
        scale={[2,2,2]}
        rotation={[0, THREE.MathUtils.degToRad(150), 0]}
        shadowScale={100}
        cameraControls={cameraControls}
        data={modelPositions[0]}
        />
      
          <PresentObject 
            ref={remoteRef}
            videos={{"objects": ["ScreenIpad", "Screen"], "file": `${contentPath}hero/Remote.mp4`}}
            src={`${contentPath}hero/Remote.glb`}
            polar={[THREE.MathUtils.degToRad(-10), 0]}
            azimuth={[THREE.MathUtils.degToRad(90), THREE.MathUtils.degToRad(0)]}
            position={modelPositions[1]["translate"][deviceType]} 
            scale={[2,2,2]}
            shadowScale={10}
            cameraControls={cameraControls}
            rotation={[0, THREE.MathUtils.degToRad(140), 0]}
            data={modelPositions[1]}

          />
       
        <Apollo 
          isLoaded={props.isLoaded}
          ref={apolloRef}
          position={modelPositions[2]["translate"][deviceType]}
          animate={animated}
          data={modelPositions[2]}
          currentScene={props.currentScene}
        />
      </group>
    )
}

const ScrollIndicator = (props) => {
  var {scrollAmount} = props
  var [currentScrollAmount, setCurrentScrollAmount] = useState(0)
  var [currentScrollDirection, setCurrentScrollDirection] = useState("")
  useEffect(() => {

  
    if(scrollAmount < 5 || scrollAmount > 97) {
      setCurrentScrollDirection("")
    } else if(scrollAmount > currentScrollAmount) {
      setCurrentScrollDirection("down")
    } else if(scrollAmount < currentScrollAmount) {
      setCurrentScrollDirection("up")
    }
   
    if(scrollAmount !== currentScrollAmount){
      setCurrentScrollAmount(scrollAmount)
    }
  }, [scrollAmount])



  return (
    <div className={`scrollindicator ${props.show}`}>
      <div className="scrollbar" style={{"height":   (scrollAmount + 2) + '%'}}>
        <div className={`scrolltext ${currentScrollDirection}`}>
          <div className="scrollbar-arrow scroll-up"><span className="demopos-arrow-up"></span></div>
          <div className="scrollbar-scroll">
            <span className="scrollbar-scroll-text">SCROLL</span>
          </div>
          <div className="scrollbar-arrow scroll-down"><span className="demopos-arrow-down"></span></div>
        </div>
      </div>
    </div>
  )
}

const FullyLoaded = (props) => {
  const {isLoaded, onComplete} = props
  useEffect(() => {
    if(isLoaded === false){
      console.log("carregado")
      onComplete()
    }
  }, [isLoaded]);

  return (isLoaded === true) ? props.children : null;
}

export const Hero = (props) => { 
  
 
  const cameraControls = useRef()

  const [modelScene, setModelScene] = useState(-1)
  const [scrollindicator, setScrollindicator] = useState(0)
  const [animated, setAnimated] = useState(false);
  const [showInteractive, setShowInteractive] = useState("");
  const [lastScene, setLastScene] = useState(false);
  const [isLoaded, setLoaded] = useState(false);
  const [modelContent, setModelContent] = useState({title: "", description: ""});
  const [isMoving, setMoving] = useState(false);
  const [heroScroll, setHeroScroll] = useState(true);
  const screenWidth = ScreenWidth()

  const sceneInfo = modelPositions[0]
    
  let deviceType = (screenWidth < mobileBreakPoint) ? "mobile" : "desktop"
  deviceType = (screenWidth >= mobileBreakPoint && screenWidth <= 1080 ) ? "ipad" : deviceType


  let initialPosition = sceneInfo.position[deviceType]
  let initialTarget = sceneInfo.target[deviceType]
  let initialOffset = sceneInfo.offset[deviceType]

  const toggleMouseWheel = () => {
    cameraControls.current.toggleMouseWheel()
  }
    
    const getCameraControls = (argument = null) => {
      let toShow = cameraControls.current
      if(argument){
        if(argument === "position"){
          toShow = toShow.getPosition().toArray()
        } else {
          toShow = toShow[argument] 
        }
      }
      console.log(toShow)
  }

  const move = (direction, animate = false) => {
    
    let newPosition = direction
    if(isNaN(direction)){
        newPosition = (direction === "back") ? modelScene - 1 : modelScene + 1
    }
    if(newPosition < 0 || newPosition > 2) return;

    if(newPosition < 2){
        document.body.classList.add('no-scroll');
    } else {
        document.body.classList.remove('no-scroll');
    }
    
    
    
    setShowInteractive("")
    var showInteractiveClass = (newPosition===0) ? "show" : ""
    
    const sceneInfo = modelPositions[newPosition]
    
    let deviceType = (screenWidth < mobileBreakPoint) ? "mobile" : "desktop"
    deviceType = (screenWidth >= mobileBreakPoint && screenWidth <= 1080 ) ? "ipad" : deviceType
  

    let viewPosition = sceneInfo.position[deviceType]
    let viewTarget = sceneInfo.target[deviceType]
    let viewOffset = sceneInfo.offset[deviceType]
    let viewDistance = sceneInfo.distance[deviceType]
    
    cameraControls.current?.setLookAt(
      viewPosition[0],
      viewPosition[1],
      viewPosition[2],
      viewTarget[0],
      viewTarget[1],
      viewTarget[2],
      true
    );
    cameraControls.current?.setFocalOffset(
        viewOffset[0],
        viewOffset[1],
        viewOffset[2],
        true
    );

    var isAnimated = (sceneInfo.animated) ? sceneInfo.animated : false
    
    document.body.classList.remove("scene-"+modelScene)
    document.body.classList.add("scene-"+newPosition)
        
    setAnimated(isAnimated)
    setModelScene(newPosition)
    
    setMoving(true)
    setTimeout(() => {
        setModelContent({...sceneInfo.content})
        setShowInteractive(showInteractiveClass)
        setTimeout(() => {
          setMoving(false)
          setTimeout(() => {
            setShowInteractive("")
          }, 2000);
        },500)
    }, 1500)
    if(cameraControls.current){

      cameraControls.current.enabled = sceneInfo.enabled
      
      if(sceneInfo.azimuth){
        cameraControls.current.minAzimuthAngle = sceneInfo.azimuth[0]
        cameraControls.current.maxAzimuthAngle = sceneInfo.azimuth[1]
      }
      if(sceneInfo.polar){
        cameraControls.current.minPolarAngle = sceneInfo.polar[0]
        cameraControls.current.maxPolarAngle = sceneInfo.polar[1]
      }
      
      if(sceneInfo.distance){
        cameraControls.current.minDistance = viewDistance[0]
        cameraControls.current.maxDistance = viewDistance[1]
      } else {
        cameraControls.current.minDistance = -Infinity
        cameraControls.current.maxDistance = Infinity
      }
    }
  }

  var canvasClass = (animated) ? "canvasStyle sky" : "canvasStyle"
  var showMenu = (isLoaded) ? "show" : ""
  var showContent = (!isMoving) ? "show" : ""
  var showLastScene = (lastScene) ? "up" : "down"
  
  var heroScrollClass = (heroScroll && isLoaded) ? "no-scroll" : ""
  var isMobile = (screenWidth < mobileBreakPoint) ? "mobile" : "desktop"
  isMobile = (screenWidth >= mobileBreakPoint && screenWidth <= 1080 ) ? "ipad" : isMobile

  var iconSize = (isMobile != "desktop" ) ? 40 : 75

  useEffect(() => {
    move(modelScene)
    console.log(isLoaded)
  }, [isMobile,isLoaded])

  useEffect(() => {
    setLastScene((modelScene===2))
  }, [modelScene])

  const scrollOptions = {
    loop: true,
    autoplay: true, 
    animationData: scrollData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  const interactOptions = {
    loop: true,
    autoplay: true, 
    animationData: interactData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };


  return (
    <div className={`heroBox ${heroScrollClass}`}>
    <div className="icons-container">
      <div className={`interact-icon ${showMenu}`}>
      <Lottie options={interactOptions}

      height={iconSize}
      width={iconSize}
      />
      <span>Click and drag to interact</span>
      </div>

      <div  className={`scroll-icon ${showMenu} ${isMobile} ${showLastScene}`}>
         <span className={`scroll-dot ${(modelScene == 0)?"active" : ""}`} onClick={() => { move(0) }}></span>
         <span className={`scroll-dot ${(modelScene == 1)?"active" : ""}`} onClick={() => { move(1) }}></span>
         <span className={`scroll-dot ${(modelScene == 2)?"active" : ""}`} onClick={() => { move(2) }}></span>
      </div>
      
    </div>
  
    <div className="modelContentContainer">
      <div className={`modelContent ${showContent} ${modelContent.align} ${isMobile} `}>
        <h2 dangerouslySetInnerHTML={{__html: modelContent.title}}></h2>
        <div className="modelDescription" dangerouslySetInnerHTML={{__html: modelContent.description}}></div>
      </div>
      
    </div>
    

   <div className={`${canvasClass}  ${showMenu}`}>
    <span className="moon">
        <img src={`${contentPath}hero/moon.png`} />
      </span>
    <Canvas   camera={{ position: [-45.88602495540558, -14.496442560521757, 2.431182357570467], fov: 35, near:2 }} onCreated={({ gl }) => { gl.outputEncoding = THREE.sRGBEncoding; gl.antialias = true }}>
    <Suspense fallback={<Loader position={[0,0,0]} ></Loader>}>
        
      <FullyLoaded isLoaded={isLoaded} onComplete={() => { setLoaded(true); move(0); props.loadContent(true)   }} />
        <hemisphereLight color={0xFFFFFF} groundColor={0x000000} intensity={1} />
            
        <HeroModels currentScene={modelScene} deviceType={isMobile} moveScroll={(amount) => { setScrollindicator(amount); }} isLoaded={isLoaded} cameraControls={cameraControls} animated={animated} moveModel={(direction) => { move(direction) }} enableScroll={(enabled) => { setHeroScroll(enabled) }}/>
            
          <Environment files={`${contentPath}hero/galaxy_2.hdr`}/>
          <CameraControls 
            ref={cameraControls} 
            focalOffset={initialOffset} 
            target={initialTarget} 
            position={initialPosition}
            enabled={true}
          />
          </Suspense>
          
          </Canvas>
          </div>
    </div>
  )
}
